import injectSheet from 'react-jss';
import classNames from 'classnames';
import {connect} from 'react-redux';

import NavigationService from '-/services/NavigationService';
import Button from '-/components/general/Button';
import greetingStyles from '-/styles/sections/greeting';
import {get} from '-/util/lodash';

const onButtonClick = () => {
    NavigationService.next('buyerInfo');
};

const NewOffer = props => {
    const {classes = {}, isCU} = props;
    const pClass = classNames('info', classes.p);

    return (
        <div>
            <h1>Welcome!</h1>
            <section className={classes.root}>
                {isCU &&
                    <>
                        <p className={pClass}>Congratulations on taking the first step towards
                        saving money! Over the next few screens, we will be asking for information
                        needed to determine your eligibility for refinancing your auto loan.</p>
                        <p className={pClass}>Once complete, we will evaluate your application
                        and contact you to let you know how much you can save. Good luck!</p>
                    </>
                }
                <Button href="#" onClick={onButtonClick} title="Get Started" btnStyle="main" tag="a">Get Started</Button>
            </section>
        </div>
    );
};

const mapStateToProps = state => {
    const dealType = get(state, 'creditor.type');

    return {
        isCU: dealType === 'creditUnion',
        isDealer: dealType === 'dealer'
    };
};

export default connect(mapStateToProps)(
    injectSheet(greetingStyles)(NewOffer)
);
